import { Badge, Flex, Text } from '@chakra-ui/react'

type Props = {
  scoreOptionKeyValue: string
  option: string
  hasAnswer?: boolean
  hasScore?: boolean
}

export default function CustomFormSelectionItem({ hasAnswer, hasScore, scoreOptionKeyValue, option }: Props) {
  return (
    <Flex align="center" justify="space-between" w="100%">
      <Flex alignItems="center" gap={2}>
        <Text color={'primary'} fontWeight={'medium'}>
          {option}
        </Text>
      </Flex>

      {hasScore && <Badge colorScheme={hasAnswer ? 'green' : 'red'}>Pontuação: {scoreOptionKeyValue}</Badge>}
    </Flex>
  )
}
